import { iAssinates, iAssinaturas } from '../../../interfaces'

// PDF exclusivo de um assinante: as demais assinaturas validas ficam de fora da
// "VERIFICACAO DE ASSINATURAS", mesmo que o documento ja tenha sido assinado por outros
export function assinaturasParaPdf (assinaturas: iAssinaturas[], assinante?: iAssinates): iAssinaturas[] {
  return assinante ? assinaturas.filter(a => a.emailAssinante === assinante.email) : assinaturas
}
